import { jsx as _jsx } from "react/jsx-runtime";
import { IconSizes, IconVariants, } from "../../../Molecules/Images/Icon/constants";
import { Icon } from "../..";
import { StyledActionIcon } from "./ActionIcon.style";
import { ActionIconSizes } from "./constants";
const ActionIcon = ({ onClick = () => { }, size = ActionIconSizes.medium, iconName = "itaufonts_outros", }) => {
    const getIconSize = (size) => {
        if (size === "small")
            return IconSizes.small;
        if (size === "medium")
            return IconSizes.medium;
        if (size === "large")
            return IconSizes.large;
    };
    return (_jsx(StyledActionIcon, { onClick: onClick, type: "button", size: size, children: iconName && (_jsx(Icon, { name: iconName, variant: IconVariants.neutral, size: getIconSize(size) })) }));
};
export default ActionIcon;
//# sourceMappingURL=ActionIcon.js.map